import appActions from "./appActions";

const initialData = {
  jobs: [],
  loading: false,
  errorMessage: null,
  searchText: "",
  transactions: [],
  topic: "",
  videoId: "",
  title: "",
};

export default (state = initialData, { type, payload }) => {
  if (type === appActions.LOADING) {
    return {
      ...state,
      loading: payload.loading,
    };
  } else if (type === appActions.BLOG_INIT) {
    return {
      ...state,
      topic: payload.topic,
      videoId: payload.videoId,
      title: payload.title,
    };
  } else if (type === appActions.BLOG_SAVE) {
    const blogs = { ...state.blogs };
    blogs[payload.id] = {
      id: payload.id,
      blog: payload.blog,
      ytbLink: payload.ytbLink,
    };
    return {
      ...state,
      blogs: blogs,
      loading: false,
    };
  }
  return state;
};
